import { Button, Modal, TextInput } from 'flowbite-react';
import Select from 'react-select';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useAppDispatch, useAppSelector } from '../../Reducers/store';
import { fetchInventoryTypes } from '../../Actions/CommonFields';
import JobApi from '../../Api/JobApi';
import Loader from '../Common/Loader';
import { Job } from '../../Models/Job';

export default function SendNotificationModal({
  show,
  setShow,
  selectedJob,
}: {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  selectedJob: Job | null;
}) {
  const { inventoryTypes } = useAppSelector((state) => state.commonFields);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);

  const onSubmit = async () => {
    setButtonDisabled(true);
    setIsLoading(true);
    return await JobApi.sendNotification(selectedJob!.id!)
      .then((res) => {
        if (res.data.success) {
          toast.success('Notification Sent!');
          setIsLoading(false);
          setButtonDisabled(false);
          onCloseModal();
        } else {
          toast.error(res.data.message);
          setIsLoading(false);
          setButtonDisabled(false);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error('Error: ' + err);
        setIsLoading(false);
        setButtonDisabled(false);
      });
  };

  function onCloseModal() {
    setShow(false);
  }

  return (
    <>
      <Modal show={show} size='2xl' onClose={onCloseModal} popup>
        <Modal.Header></Modal.Header>
        <Modal.Body>
          <div className='relative'>
            {isLoading && <Loader />}
            <div className='w-full'>
              <div className='mx-1 flex items-end justify-center'>
                <h1 className='text-gray-900 font-bold text-4xl'>
                  Send Text Notification
                </h1>
              </div>
            </div>
            <div>
              <div className='container mx-auto p-2'>
                <div>
                  A Fuel Pro Driver is on their way to your location. His name
                  is {selectedJob?.user?.firstName ?? 'N/A'}{' '}
                  {selectedJob?.user?.lastName ?? 'N/A'} and phone number is{' '}
                  {selectedJob?.user?.phoneNumber ?? 'N/A'} and should be onsite
                  in the next 2 hours."
                </div>
                <br />
                <div>
                  Send this to {selectedJob?.clientLocation?.contactName} at{' '}
                  {selectedJob?.clientLocation?.contactPhone}?
                </div>
                <div className='flex justify-end pt-2'>
                  <Button
                    disabled={buttonDisabled}
                    type='button'
                    className='buttonMain'
                    onClick={onSubmit}
                  >
                    Send
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
